(function () {
  var READY_RING_CIRC = 352;

  function parseOptions(raw) {
    if (!raw) return [];
    return raw
      .split(/\r?\n/)
      .map(function (line) {
        return line.trim();
      })
      .filter(Boolean)
      .map(function (line) {
        var parts = line.split('|');
        return {
          value: (parts[0] || '').trim(),
          label: (parts[1] || parts[0] || '').trim(),
          hint: (parts[2] || '').trim()
        };
      });
  }

  function inArray(arr, value) {
    return Array.isArray(arr) && arr.indexOf(value) >= 0;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function stripTags(value) {
    return String(value == null ? '' : value).replace(/<[^>]*>/g, '');
  }

  function decorateIntroHeading(value) {
    var raw = String(value || '');
    var text = stripTags(raw).trim();
    if (raw.indexOf('<') === -1 && text.indexOf('actually fits your nights') >= 0) {
      return escapeHtml(text).replace(
        'actually fits your nights.',
        '<br><span class="quite-title--brand">actually fits your nights.</span>'
      );
    }
    return raw;
  }

  function makeGradientId(sectionId) {
    return 'quite-ready-gradient-' + String(sectionId || 'section').replace(/[^a-zA-Z0-9_-]/g, '-');
  }

  function deriveProfile(answers) {
    var q1 = answers.q1;
    var q2 = Number(answers.q2 || 0);
    var q3 = answers.q3 || [];
    var q4 = answers.q4 || [];
    var q5 = answers.q5 || [];
    var q6 = answers.q6;
    var q7 = answers.q7;
    var q10 = answers.q10 || [];
    var sideSleeper = q1 === 'side' || q1 === 'mix';
    var severe = q2 >= 4;
    var partnerSnore = inArray(q3, 'snoring');
    var urban = inArray(q3, 'city') || inArray(q3, 'neighbors');
    var traveler = inArray(q3, 'travel');
    var internal = inArray(q3, 'internal');
    var triedAndFailed = q4.length > 0 && !(q4.length === 1 && q4[0] === 'nothing');
    var hurtOnSide = inArray(q5, 'hurt');
    var alarmFear = q7 === 'yes' || q7 === 'little' || inArray(q5, 'alarm');
    var pillowProblem = q6 === 'always' || q6 === 'sometimes' || q6 === 'worried';
    var profile;

    if (sideSleeper && partnerSnore) {
      profile = {
        name: 'The Pillow-Side Snore Survivor',
        kicker: 'Side sleeper. Snoring partner. Sore ears.',
        summary: 'You are sleeping next to a snorer, on the side they roll toward, with earplugs that tend to dig in. The fix is not louder white noise. It is an earplug soft enough to lie on.'
      };
    } else if (sideSleeper && urban) {
      profile = {
        name: 'The Pillow-Side City Sleeper',
        kicker: 'Thin walls. Loud street. Side sleeper.',
        summary: 'Your room has a soundtrack you did not sign up for. The pillow side makes most earplugs unwearable. You need something soft enough to forget about and quiet enough to matter.'
      };
    } else if (partnerSnore && severe) {
      profile = {
        name: 'The Bed-Share Survivor',
        kicker: 'You love them. You cannot sleep next to them.',
        summary: 'Snoring is stealing your nights. You do not need to move to the couch. You need the noise turned down enough to stay asleep.'
      };
    } else if (urban && severe) {
      profile = {
        name: 'The Light-Sleeping City Dweller',
        kicker: 'Sirens, footsteps, and 3 a.m. wake-ups.',
        summary: 'The 4 a.m. truck, the neighbor, the hallway door. You need quiet that is reliable, comfortable, and honest about what it can do.'
      };
    } else if (traveler) {
      profile = {
        name: 'The Hotel-Hall Insomniac',
        kicker: 'Travel should not cost you a week of sleep.',
        summary: 'The hotel hallway, the plane, and the friend guest room all need the same thing: a sleep tool small enough to pack and soft enough to wear.'
      };
    } else if (internal) {
      profile = {
        name: 'The Tinnitus / Racing-Thoughts Sleeper',
        kicker: 'When the room is quiet, your head is not.',
        summary: 'Earplugs alone cannot fix a busy brain, but lowering the outside noise floor can give your inside noise less to hook onto.'
      };
    } else if (sideSleeper) {
      profile = {
        name: 'The Sore-Ear Side Sleeper',
        kicker: 'Every earplug you have tried, you have slept on.',
        summary: 'You are not picky. You are physics. Hard earplugs and a pillow are a bad pair. You need something built to be lain on.'
      };
    } else {
      profile = {
        name: 'The Noise-Sensitive Sleeper',
        kicker: 'You wake up to things other people sleep through.',
        summary: 'Your nervous system runs hot at 3 a.m. You do not need silence. You need a noise floor low enough to keep you under.'
      };
    }

    var matchedOn = [];
    if (sideSleeper) matchedOn.push({ icon: 'bed', label: 'Pillow-side comfort prioritized' });
    if (partnerSnore) matchedOn.push({ icon: 'volume-x', label: 'Tuned for partner snoring' });
    if (urban) matchedOn.push({ icon: 'home', label: 'Built for city and neighbor noise' });
    if (traveler) matchedOn.push({ icon: 'plane', label: 'Reusable and cased for travel' });
    if (alarmFear) matchedOn.push({ icon: 'alarm', label: 'Quiet, not cut off from alarms' });
    if (pillowProblem || hurtOnSide) matchedOn.push({ icon: 'ear', label: 'Soft silicone designed to be lain on' });
    if (triedAndFailed) matchedOn.push({ icon: 'rotate', label: '60-night sleep-on-it guarantee' });
    if (inArray(q10, 'rested')) matchedOn.push({ icon: 'moon-star', label: 'Focused on staying asleep longer' });
    if (matchedOn.length < 3) {
      matchedOn.push({ icon: 'leaf', label: 'Body-safe reusable silicone' });
      matchedOn.push({ icon: 'shield', label: 'Up to 27 dB noise reduction' });
    }

    var wantsSilence = Number(answers.q9 || 50);
    var honestNote;
    if (wantsSilence > 65) {
      honestNote = 'Heads up: if you were hoping for total silence, Quiet will probably disappoint you. No comfortable passive earplug delivers that. What Quiet does is turn disruptive noise down enough that you have a better shot at staying asleep.';
    } else if (wantsSilence < 35) {
      honestNote = 'You already think about earplugs the way we do: a way to turn the night down, not switch it off. Quiet is built around exactly that.';
    } else {
      honestNote = 'Quiet does not promise total silence. What it does is turn disruptive noise down by up to about 27 dB, so you can stay asleep through more of the things that used to wake you up.';
    }

    return {
      profile: profile,
      recommendedSize: 'M',
      matchedOn: matchedOn.slice(0, 5),
      honestNote: honestNote
    };
  }

  function createEl(tag, className, html) {
    var el = document.createElement(tag);
    if (className) el.className = className;
    if (html != null) el.innerHTML = html;
    return el;
  }

  function iconMarkup(name, size) {
    var paths = {
      bed: '<path d="M2 17v-7a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v7"></path><path d="M2 20h20"></path><circle cx="7" cy="11.5" r="1.5"></circle><path d="M10 13h10"></path>',
      'volume-x': '<path d="M11 5 6 9H2v6h4l5 4V5Z"></path><path d="m22 9-6 6"></path><path d="m16 9 6 6"></path>',
      home: '<path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2h-4v-7h-5v7H6a2 2 0 0 1-2-2V9Z"></path>',
      plane: '<path d="m17.8 19.2-1.8-8.2 3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 5 6 4 7l6 5-3 3-3 .5L4 17l3-1 1.5 1.5L9 21l1-1 .5-3 3-3 5 6Z"></path>',
      alarm: '<circle cx="12" cy="13" r="8"></circle><path d="M12 9v4l2 2"></path><path d="M5 3 2 6"></path><path d="m19 3 3 3"></path>',
      ear: '<path d="M6 8.5a6.5 6.5 0 1 1 13 0c0 6-6 7-6 11a3 3 0 1 1-6 0"></path><path d="M9 13a2 2 0 1 1 4 0"></path>',
      rotate: '<path d="M1 4v6h6"></path><path d="M3.5 15a9 9 0 1 0 2.4-9.4L1 10"></path>',
      leaf: '<path d="M11 20A7 7 0 0 1 4 13C4 6 11 2 20 4c2 9-2 16-9 16Z"></path><path d="M4 22c4-8 8-12 16-12"></path>',
      shield: '<path d="M12 22s8-4 8-12V5l-8-3-8 3v5c0 8 8 12 8 12Z"></path><path d="m9 12 2 2 4-4"></path>',
      'moon-star': '<path d="M21 12.8A9 9 0 1 1 11.2 3 7 7 0 0 0 21 12.8Z"></path><path d="m19 3 1 2 2 1-2 1-1 2-1-2-2-1 2-1 1-2Z"></path>',
      check: '<path d="m20 6-11 11-5-5"></path>',
      'chevron-right': '<path d="m9 18 6-6-6-6"></path>',
      'chevron-left': '<path d="m15 18-6-6 6-6"></path>',
      truck: '<path d="M10 17h4V5H2v12h3"></path><path d="M14 8h4l4 4v5h-3"></path><circle cx="7.5" cy="17.5" r="2.5"></circle><circle cx="16.5" cy="17.5" r="2.5"></circle>'
    };
    var iconSize = size || 20;
    return '<svg class="quite-icon" width="' + iconSize + '" height="' + iconSize + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + (paths[name] || paths['moon-star']) + '</svg>';
  }

  function initQuiz(root) {
    if (root.__quiteQuizDestroy) root.__quiteQuizDestroy();

    var destroyed = false;
    var timers = [];
    var configScript = root.querySelector('[data-quite-quiz-config]');
    if (!configScript) return;

    var config = JSON.parse(configScript.textContent);
    var questions = config.questions.map(function (q) {
      q.options = parseOptions(q.optionsRaw);
      return q;
    });
    var answers = {};
    var screen = 'intro';
    var main = root.querySelector('[data-quiz-main]');
    var header = root.querySelector('.quite-quiz__header');
    var counter = root.querySelector('[data-quiz-counter]');
    var progress = root.querySelector('[data-quiz-progress]');
    var progressWrap = progress && progress.parentNode;
    var skipLinks = root.querySelectorAll('[data-product-link]');
    var storageKey = 'quite_quiz_state_' + config.sectionId;
    var transitionTimer = null;
    var readyTimer = null;
    var motionDirection = 'forward';

    function schedule(fn, delay) {
      var id = window.setTimeout(function () {
        timers = timers.filter(function (timerId) {
          return timerId !== id;
        });
        if (!destroyed) fn();
      }, delay);
      timers.push(id);
      return id;
    }

    function clearTimer(id) {
      if (!id) return null;
      window.clearTimeout(id);
      timers = timers.filter(function (timerId) {
        return timerId !== id;
      });
      return null;
    }

    function destroy() {
      destroyed = true;
      timers.forEach(function (id) {
        window.clearTimeout(id);
      });
      timers = [];
    }

    root.__quiteQuizDestroy = destroy;

    try {
      var saved = JSON.parse(localStorage.getItem(storageKey) || '{}');
      if (saved.answers) answers = saved.answers;
      if (saved.screen != null && saved.screen !== 'contact') screen = saved.screen;
    } catch (error) {
      answers = {};
      screen = 'intro';
    }

    skipLinks.forEach(function (link) {
      link.href = config.productUrl || '#';
      if (!config.productUrl) link.setAttribute('aria-disabled', 'true');
      link.addEventListener('click', function () {
        if (window.qtrack) window.qtrack('quiz_skip', { from_screen: String(screen) });
      });
    });

    function save() {
      try {
        localStorage.setItem(storageKey, JSON.stringify({ answers: answers, screen: screen }));
      } catch (error) {}
    }

    function activeQuestions() {
      return questions.filter(function (q) {
        if (!q.skipQuestionId || !q.skipValue) return true;
        var value = answers[q.skipQuestionId];
        if (Array.isArray(value)) return value.indexOf(q.skipValue) < 0;
        return value !== q.skipValue;
      });
    }

    function screenRank(value) {
      var active = activeQuestions();
      if (value === 'intro') return -1;
      if (value === 'ready') return active.length;
      if (value === 'results') return active.length + 1;
      if (typeof value === 'number') return value;
      return 0;
    }

    function setScreen(next) {
      var current = main.querySelector('.quite-quiz__screen');
      motionDirection = screenRank(next) < screenRank(screen) ? 'back' : 'forward';
      transitionTimer = clearTimer(transitionTimer);
      readyTimer = clearTimer(readyTimer);

      if (current) {
        current.classList.remove('is-entering', 'is-entering-back');
        current.classList.add(motionDirection === 'back' ? 'is-leaving-back' : 'is-leaving');
        main.classList.add('is-transitioning');
        transitionTimer = schedule(function () {
          screen = next;
          save();
          render();
          main.classList.remove('is-transitioning');
          window.scrollTo({ top: 0, behavior: 'auto' });
        }, 280);
        return;
      }

      screen = next;
      save();
      render();
      window.scrollTo({ top: 0, behavior: 'auto' });
    }

    function setAnswer(id, value) {
      answers[id] = value;
      save();
    }

    function updateProgress(index, total) {
      if (index == null) {
        root.classList.remove('quite-quiz--has-progress');
        if (counter) counter.textContent = '';
        if (progress) progress.style.width = '0%';
        if (progressWrap) progressWrap.classList.remove('is-pulsing');
        return;
      }

      var pct = Math.round((index / total) * 100);
      root.classList.add('quite-quiz--has-progress');
      if (counter) {
        counter.innerHTML = index + ' <span>/</span> ' + total;
        counter.classList.remove('is-pulsing');
        void counter.offsetWidth;
        counter.classList.add('is-pulsing');
      }
      if (progress && progressWrap) {
        progress.style.width = pct + '%';
        progressWrap.style.setProperty('--quite-progress-left', pct + '%');
        progressWrap.classList.remove('is-pulsing');
        void progressWrap.offsetWidth;
        progressWrap.classList.add('is-pulsing');
      }
    }

    function isAnswered(q) {
      var value = answers[q.id];
      if (q.type === 'multi') return Array.isArray(value) && value.length > 0;
      if (q.type === 'slider' || q.type === 'anchored-slider') return value != null;
      return value != null && value !== '';
    }

    function renderShell(extraClass) {
      readyTimer = clearTimer(readyTimer);
      main.innerHTML = '';
      var screenClass = 'quite-quiz__screen ' + (motionDirection === 'back' ? 'is-entering-back' : 'is-entering');
      if (extraClass) screenClass += ' ' + extraClass;
      var screenEl = createEl('div', screenClass);
      main.appendChild(screenEl);
      return screenEl;
    }

    function renderIntro() {
      updateProgress(null);
      var target = renderShell('quite-quiz__screen--intro');
      target.innerHTML =
        '<section class="quite-quiz__intro quite-sand-blobs">' +
          '<div class="quite-container--narrow quite-center">' +
            '<p class="quite-eyebrow quite-anim-eyebrow">' + escapeHtml(config.introEyebrow) + '</p>' +
            '<h1 class="quite-title quite-title--xl quite-anim-title">' + decorateIntroHeading(config.introHeading) + '</h1>' +
            '<div class="quite-divider quite-divider--center quite-anim-divider"></div>' +
            '<div class="quite-lead quite-anim-copy">' + (config.introBody || '') + '</div>' +
            '<div class="quite-quiz__pill-row quite-anim-pills">' +
              '<span class="quite-chip"><span class="quite-icon-bubble">' + iconMarkup('moon-star') + '</span>For side and light sleepers</span>' +
              '<span class="quite-chip"><span class="quite-icon-bubble">' + iconMarkup('shield') + '</span>No fake silence promises</span>' +
              '<span class="quite-chip"><span class="quite-icon-bubble">' + iconMarkup('rotate') + '</span>60-night guarantee</span>' +
            '</div>' +
            '<div class="quite-anim-cta"><button type="button" class="quite-btn quite-btn--large" data-start>' + escapeHtml(config.startLabel) + iconMarkup('chevron-right', 18) + '</button></div>' +
            '<p class="quite-quiz__small quite-anim-small">Already know what you want? <a class="quite-link" data-product-link href="' + escapeHtml(config.productUrl || '#') + '">' + escapeHtml(config.skipLabel) + '</a></p>' +
          '</div>' +
        '</section>';
      target.querySelector('[data-start]').addEventListener('click', function () {
        if (window.qtrack) window.qtrack('quiz_start', { quiz_total: activeQuestions().length });
        setScreen(0);
      });
    }

    function renderChoices(container, q) {
      var list = createEl('div', 'quite-choice-list' + (q.type === 'multi' ? ' quite-choice-list--multi' : ''));
      q.options.forEach(function (option, optionIndex) {
        var selected = q.type === 'multi' ? inArray(answers[q.id], option.value) : answers[q.id] === option.value;
        var button = createEl('button', 'quite-choice' + (selected ? ' is-selected' : ''));
        button.type = 'button';
        button.setAttribute('data-multi', q.type === 'multi' ? 'true' : 'false');
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        button.style.setProperty('--choice-index', optionIndex);
        button.innerHTML =
          '<span class="quite-choice__ring" aria-hidden="true"></span>' +
          '<span class="quite-choice__dot" aria-hidden="true">' + (q.type === 'multi' ? iconMarkup('check', 14) : '') + '</span>' +
          '<span class="quite-choice__copy"><span class="quite-choice__label">' + escapeHtml(option.label) + '</span>' +
          (option.hint ? '<span class="quite-choice__hint">' + escapeHtml(option.hint) + '</span>' : '') +
          '</span>';
        button.addEventListener('click', function () {
          if (q.type === 'multi') {
            var current = Array.isArray(answers[q.id]) ? answers[q.id].slice() : [];
            var index = current.indexOf(option.value);
            if (index >= 0) current.splice(index, 1);
            else current.push(option.value);
            setAnswer(q.id, current);

            var nowSelected = inArray(answers[q.id], option.value);
            button.classList.toggle('is-selected', nowSelected);
            button.setAttribute('aria-pressed', nowSelected ? 'true' : 'false');
            if (nowSelected) {
              button.classList.add('is-selecting');
              schedule(function () {
                button.classList.remove('is-selecting');
              }, 420);
            } else {
              button.classList.remove('is-selecting');
            }

            var section = button.closest('.quite-quiz__question');
            var continueButton = section && section.querySelector('[data-continue]');
            if (continueButton) continueButton.disabled = !isAnswered(q);
            return;
          }

          list.querySelectorAll('.quite-choice').forEach(function (item) {
            item.classList.remove('is-selected', 'is-pulsing');
            item.setAttribute('aria-pressed', 'false');
          });
          button.classList.add('is-selected', 'is-pulsing');
          button.setAttribute('aria-pressed', 'true');
          setAnswer(q.id, option.value);
          schedule(goNext, 520);
        });
        list.appendChild(button);
      });
      container.appendChild(list);
    }

    function sliderLabel(q, value) {
      if (q.type === 'slider' && q.format === 'nights') {
        return Number(value) === 1 ? '1 night a week' : value + ' nights a week';
      }
      return value;
    }

    function updateSliderUI(card, q, value) {
      var min = Number(q.min);
      var max = Number(q.max);
      var pct = ((Number(value) - min) / (max - min)) * 100;
      var left = 0;
      var width = pct;
      var fill = 'linear-gradient(90deg, var(--quite-dusk-400), var(--quite-dusk-600))';
      var thumb = 'var(--quite-dusk-500)';

      if (q.type === 'anchored-slider') {
        if (Math.abs(pct - 50) < 0.4) {
          left = 50;
          width = 0;
          fill = 'transparent';
          thumb = 'var(--quite-sand-400)';
          card.classList.add('is-centered');
        } else if (pct < 50) {
          left = pct;
          width = 50 - pct;
          fill = 'linear-gradient(90deg, rgba(91, 122, 94, 0.50), rgba(91, 122, 94, 0.78))';
          thumb = 'var(--quite-success)';
          card.classList.remove('is-centered');
        } else {
          left = 50;
          width = pct - 50;
          fill = 'linear-gradient(90deg, rgba(184, 132, 58, 0.50), rgba(184, 132, 58, 0.78))';
          thumb = 'var(--quite-warning)';
          card.classList.remove('is-centered');
        }
      }

      card.style.setProperty('--quite-slider-pct', pct + '%');
      card.style.setProperty('--quite-slider-fill-left', left + '%');
      card.style.setProperty('--quite-slider-fill-width', width + '%');
      card.style.setProperty('--quite-slider-fill', fill);
      card.style.setProperty('--quite-slider-thumb-color', thumb);

      var valueEl = card.querySelector('[data-slider-value]');
      if (valueEl) valueEl.textContent = sliderLabel(q, value);
    }

    function renderSlider(container, q) {
      if (answers[q.id] == null) setAnswer(q.id, q.defaultValue);
      var value = answers[q.id];
      var isAnchored = q.type === 'anchored-slider';
      var card = createEl('div', 'quite-slider-card' + (isAnchored ? ' is-anchored' : ''));

      if (isAnchored) {
        card.innerHTML =
          '<div class="quite-anchor-options">' +
            '<div class="quite-anchor-card"><strong>' + escapeHtml(q.leftShort) + '</strong><span>' + escapeHtml(q.leftLabel) + '</span></div>' +
            '<div class="quite-anchor-card"><strong>' + escapeHtml(q.rightShort) + '</strong><span>' + escapeHtml(q.rightLabel) + '</span></div>' +
          '</div>';
      } else {
        card.innerHTML = '<div class="quite-slider-value" data-slider-value>' + escapeHtml(sliderLabel(q, value)) + '</div>';
      }

      var control = createEl('div', 'quite-slider-control');
      control.innerHTML =
        '<div class="quite-slider-track" aria-hidden="true"><span class="quite-slider-fill"></span></div>' +
        (isAnchored ? '<span class="quite-slider-center" aria-hidden="true"></span>' : '') +
        '<span class="quite-slider-ring" aria-hidden="true"></span>' +
        '<span class="quite-slider-thumb" aria-hidden="true"></span>';

      var input = createEl('input', 'quite-slider-input');
      input.type = 'range';
      input.min = q.min;
      input.max = q.max;
      input.step = q.step;
      input.value = value;
      input.setAttribute('aria-label', q.title);
      input.addEventListener('input', function () {
        setAnswer(q.id, Number(input.value));
        updateSliderUI(card, q, input.value);
        card.classList.add('is-scrubbing');
      });
      input.addEventListener('change', function () {
        card.classList.remove('is-scrubbing');
      });

      control.appendChild(input);
      card.appendChild(control);
      card.appendChild(createEl('div', 'quite-slider-labels', '<span>' + escapeHtml(isAnchored ? q.leftShort : q.leftLabel) + '</span><span>' + escapeHtml(isAnchored ? q.rightShort : q.rightLabel) + '</span>'));
      container.appendChild(card);
      updateSliderUI(card, q, value);
    }

    function goNext() {
      var active = activeQuestions();
      if (typeof screen === 'number') {
        try {
          if (window.qtrack) {
            var cq = active[screen];
            if (cq) {
              var av = answers[cq.id];
              window.qtrack('quiz_answer', {
                quiz_question_id: cq.id,
                quiz_question_index: screen + 1,
                quiz_answer_value: (Array.isArray(av) ? av.join('|') : String(av)).slice(0, 100)
              });
            }
          }
        } catch (e) {}
        if (screen < active.length - 1) setScreen(screen + 1);
        else setScreen('ready');
      } else if (screen === 'intro') {
        setScreen(0);
      } else if (screen === 'ready') {
        setScreen('results');
      }
    }

    function goBack() {
      var active = activeQuestions();
      if (typeof screen === 'number') {
        if (screen === 0) setScreen('intro');
        else setScreen(screen - 1);
      } else if (screen === 'ready') {
        setScreen(active.length - 1);
      } else if (screen === 'results') {
        setScreen('ready');
      }
    }

    function renderQuestion(index) {
      var active = activeQuestions();
      var q = active[index];
      if (!q) {
        setScreen('intro');
        return;
      }
      updateProgress(index + 1, active.length);
      if (window.qtrack) window.qtrack('quiz_step_view', { quiz_question_id: q.id, quiz_question_index: index + 1, quiz_total: active.length });
      var target = renderShell('quite-quiz__screen--question');
      var section = createEl('section', 'quite-quiz__question');
      section.innerHTML =
        '<div class="quite-container--narrow">' +
          '<p class="quite-eyebrow quite-anim-eyebrow">' + escapeHtml(q.section) + '</p>' +
          '<h2 class="quite-title quite-title--md quite-anim-title">' + escapeHtml(q.title) + '</h2>' +
          (q.subtitle ? '<p class="quite-lead quite-anim-copy">' + escapeHtml(q.subtitle) + '</p>' : '') +
          '<div data-question-body></div>' +
          (q.type === 'multi' ? '<p class="quite-quiz__helper quite-anim-helper">Pick all that apply.</p>' : '') +
          '<div class="quite-quiz__nav quite-anim-nav">' +
            '<button type="button" class="quite-quiz__ghost" data-back>' + iconMarkup('chevron-left', 16) + 'Back</button>' +
            (q.type === 'single' ? '<span class="quite-quiz__pick-one">Pick one to continue</span>' : '<button type="button" class="quite-btn" data-continue>Continue' + iconMarkup('chevron-right', 16) + '</button>') +
          '</div>' +
        '</div>';
      target.appendChild(section);

      var body = section.querySelector('[data-question-body]');
      if (q.type === 'single' || q.type === 'multi') renderChoices(body, q);
      else renderSlider(body, q);

      var backButton = section.querySelector('[data-back]');
      backButton.disabled = index === 0;
      backButton.addEventListener('click', function () {
        if (!backButton.disabled) goBack();
      });

      var continueButton = section.querySelector('[data-continue]');
      if (!continueButton) return;
      continueButton.disabled = !isAnswered(q);
      continueButton.addEventListener('click', function () {
        if (!isAnswered(q)) return;
        section.classList.add('is-confirming');
        section.querySelectorAll('.quite-choice.is-selected').forEach(function (choice) {
          choice.classList.add('is-confirming');
        });
        var sliderCard = section.querySelector('.quite-slider-card');
        if (sliderCard) sliderCard.classList.add('is-confirming');
        continueButton.disabled = true;
        schedule(goNext, 520);
      });
    }

    function renderReady() {
      updateProgress(null);
      var target = renderShell('quite-quiz__screen--ready');
      var gradientId = makeGradientId(config.sectionId);
      target.innerHTML =
        '<section class="quite-ready quite-sand-blobs">' +
          '<div class="quite-container--narrow quite-center">' +
            '<div class="quite-ready-meter" data-ready-meter>' +
              '<div class="quite-ready-halo" data-ready-halo></div>' +
              '<svg class="quite-ready-svg" width="132" height="132" viewBox="0 0 132 132" aria-hidden="true">' +
                '<circle class="quite-ready-track" cx="66" cy="66" r="56"></circle>' +
                '<g class="quite-ready-dots"><circle cx="66" cy="66" r="44"></circle></g>' +
                '<circle class="quite-ready-fill" data-ready-fill cx="66" cy="66" r="56" stroke="url(#' + gradientId + ')"></circle>' +
                '<defs><linearGradient id="' + gradientId + '" x1="0" y1="0" x2="132" y2="132" gradientUnits="userSpaceOnUse"><stop offset="0%" stop-color="var(--quite-dusk-400)"></stop><stop offset="100%" stop-color="var(--quite-dusk-600)"></stop></linearGradient></defs>' +
              '</svg>' +
              '<span class="quite-ready-icon" data-ready-icon>' + iconMarkup('moon-star', 44) + '</span>' +
              '<span class="quite-ready-percent" data-ready-percent>0% complete</span>' +
            '</div>' +
            '<div class="quite-ready-status-wrap"><p class="quite-eyebrow quite-ready-status" data-ready-status>Reading your answers...</p></div>' +
            '<h2 class="quite-title quite-title--lg quite-anim-title" data-ready-heading>Building your profile.</h2>' +
            '<div class="quite-divider quite-divider--center quite-anim-divider"></div>' +
            '<p class="quite-lead quite-anim-copy" data-ready-copy>Cross-referencing your sleep position, your noise sources, and what has already failed you.</p>' +
            '<div class="quite-ready-actions quite-anim-nav">' +
              '<button type="button" class="quite-btn quite-btn--large" data-results disabled>Get my results' + iconMarkup('chevron-right', 18) + '</button>' +
              '<button type="button" class="quite-quiz__ghost quite-quiz__ghost--text" data-back>' + iconMarkup('chevron-left', 14) + 'Change my last answer</button>' +
            '</div>' +
          '</div>' +
        '</section>';

      var resultButton = target.querySelector('[data-results]');
      var readySection = target.querySelector('.quite-ready');
      var status = target.querySelector('[data-ready-status]');
      var meter = target.querySelector('[data-ready-meter]');
      var halo = target.querySelector('[data-ready-halo]');
      var icon = target.querySelector('[data-ready-icon]');
      var percent = target.querySelector('[data-ready-percent]');
      var fill = target.querySelector('[data-ready-fill]');
      var heading = target.querySelector('[data-ready-heading]');
      var copy = target.querySelector('[data-ready-copy]');
      var stages = [
        { label: 'Reading your answers...', dur: 1100, ringTo: 0.22 },
        { label: 'Cross-referencing sleep patterns...', dur: 1200, ringTo: 0.48 },
        { label: 'Matching against profiles...', dur: 1100, ringTo: 0.74 },
        { label: 'Calibrating your fit...', dur: 1000, ringTo: 0.96 },
        { label: 'Profile ready', dur: 9999, ringTo: 1 }
      ];
      var stageIndex = 0;

      fill.style.strokeDasharray = READY_RING_CIRC;
      fill.style.strokeDashoffset = READY_RING_CIRC;
      halo.classList.add('is-active');

      function applyReadyStage() {
        var stage = stages[stageIndex];
        var ready = stageIndex >= stages.length - 1;
        status.textContent = stage.label;
        fill.style.strokeDashoffset = READY_RING_CIRC * (1 - stage.ringTo);
        percent.textContent = Math.round(stage.ringTo * 100) + '% complete';
        status.classList.remove('is-swapping');
        void status.offsetWidth;
        status.classList.add('is-swapping');

        if (ready) {
          readySection.classList.add('is-done');
          meter.classList.add('is-done');
          halo.classList.remove('is-active');
          halo.classList.add('is-done');
          icon.innerHTML = iconMarkup('check', 48);
          percent.textContent = '';
          heading.textContent = 'Your nights, decoded.';
          copy.textContent = 'We have matched you with a Sleep Noise Profile and a recommended fit. Take a look.';
          resultButton.disabled = false;
          resultButton.classList.add('is-ready');
          return;
        }

        readyTimer = schedule(function () {
          stageIndex += 1;
          applyReadyStage();
        }, stage.dur);
      }

      readyTimer = schedule(applyReadyStage, 40);
      resultButton.addEventListener('click', function () {
        if (!resultButton.disabled) setScreen('results');
      });
      target.querySelector('[data-back]').addEventListener('click', goBack);
    }

    function renderResults() {
      updateProgress(null);
      var result = deriveProfile(answers);
      if (window.qtrack) window.qtrack('quiz_complete', {
        quiz_profile: (result && result.profile && result.profile.name) ? result.profile.name : '',
        quiz_answered_count: Object.keys(answers || {}).length
      });
      if (Array.isArray(config.fallbackFeatures)) {
        config.fallbackFeatures.forEach(function (feature) {
          if (result.matchedOn.length < 5) result.matchedOn.push(feature);
        });
      }

      var target = renderShell('quite-quiz__screen--results');
      var productTitle = config.productTitle || 'Select Quiet Premium EarPlugs in the theme editor';
      var ctaLabel = config.productUrl ? config.resultCta : 'Select the recommended product in the theme editor';
      var productImage = config.productImage || config.fallbackImage;
      var featureHtml = result.matchedOn.map(function (item, index) {
        return '<li style="--match-index:' + index + '"><span class="quite-icon-bubble">' + iconMarkup(item.icon) + '</span><span>' + escapeHtml(item.label) + '</span></li>';
      }).join('');

      target.innerHTML =
        '<section class="quite-result-hero quite-sand-blobs">' +
          '<div class="quite-container--narrow quite-center">' +
            '<p class="quite-eyebrow quite-anim-eyebrow">' + escapeHtml(config.resultEyebrow) + '</p>' +
            '<h1 class="quite-title quite-title--xl quite-anim-title">' + escapeHtml(result.profile.name) + '</h1>' +
            '<div class="quite-divider quite-divider--center quite-anim-divider"></div>' +
            '<p class="quite-result-kicker quite-anim-copy">' + escapeHtml(result.profile.kicker) + '</p>' +
            '<p class="quite-lead quite-anim-copy">' + escapeHtml(result.profile.summary) + '</p>' +
          '</div>' +
        '</section>' +
        '<section class="quite-result-match">' +
          '<div class="quite-container">' +
            '<div class="quite-results-card">' +
              '<div class="quite-results-card__image"><span class="quite-results-card__badge"><i></i>Your match</span><img src="' + escapeHtml(productImage) + '" alt="' + escapeHtml(productTitle) + '"></div>' +
              '<div class="quite-results-card__body">' +
                '<p class="quite-eyebrow">Matched product</p>' +
                '<h2 class="quite-title quite-title--md">' + escapeHtml(productTitle) + '</h2>' +
                '<p class="quite-lead">' + escapeHtml(config.productSubtext) + '</p>' +
                '<div class="quite-size-note"><span>' + escapeHtml(result.recommendedSize) + '</span><p><strong>Start with size ' + escapeHtml(result.recommendedSize) + '.</strong> All four sizes ship in the box, so you can swap if it is not right.</p></div>' +
                '<p class="quite-eyebrow">Why this match</p>' +
                '<ul class="quite-match-list">' + featureHtml + '</ul>' +
                (config.productPrice ? '<div class="quite-quiz__result-price"><span>' + escapeHtml(config.productPrice) + '</span><small>Launch offer shown on the product page</small></div>' : '') +
                '<a class="quite-btn quite-btn--large quite-btn--block" data-result-link href="' + escapeHtml(config.productUrl || '#') + '">' + escapeHtml(ctaLabel) + (config.productPrice ? ' - ' + escapeHtml(config.productPrice) : '') + iconMarkup('chevron-right', 18) + '</a>' +
                '<div class="quite-result-trust"><span>' + iconMarkup('rotate', 14) + '60-night guarantee</span><span>' + iconMarkup('truck', 14) + 'Ships in 24h</span></div>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</section>' +
        '<section class="quite-honest-section">' +
          '<div class="quite-container--narrow">' +
            '<div class="quite-honest-note"><p class="quite-eyebrow">Honest note</p><div>' + escapeHtml(result.honestNote) + '</div></div>' +
          '</div>' +
        '</section>' +
        '<section class="quite-restart-section"><button type="button" class="quite-quiz__ghost" data-restart>' + iconMarkup('rotate', 14) + 'Retake the quiz</button></section>';

      target.querySelector('[data-restart]').addEventListener('click', function () {
        answers = {};
        try { localStorage.removeItem(storageKey); } catch (error) {}
        setScreen('intro');
      });

      target.querySelector('[data-result-link]').addEventListener('click', function (event) {
        if (window.qtrack) window.qtrack('quiz_reveal_cta_click', {
          quiz_profile: (result && result.profile && result.profile.name) ? result.profile.name : '',
          cta_href: config.productUrl || ''
        });
        if (!config.productUrl) {
          event.preventDefault();
          return;
        }
        event.preventDefault();
        var overlay = root.querySelector('[data-page-transition]');
        if (overlay) overlay.classList.add('is-active');
        schedule(function () {
          window.location.href = config.productUrl;
        }, 560);
      });
    }

    function render() {
      if (destroyed) return;
      if (header) header.classList.toggle('is-quiz-active', typeof screen === 'number');
      if (screen === 'intro') renderIntro();
      else if (typeof screen === 'number') renderQuestion(screen);
      else if (screen === 'ready') renderReady();
      else if (screen === 'results') renderResults();
    }

    render();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-quite-quiz]').forEach(initQuiz);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target || document);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    (event.target || document).querySelectorAll('[data-quite-quiz]').forEach(function (root) {
      if (root.__quiteQuizDestroy) root.__quiteQuizDestroy();
    });
  });
})();
